import type { TypeEntreprise } from '@/features/domaine/types/opco/shared/TypeEntreprise'
import type { PermissionsApp } from './PermissionsApp'
import type { EnumLibellé } from '@/features/domaine/types/techniques/EnumLibellé'

export enum TypesContextesAutorisesEnum {
  Aucun = 0,
  Adherent = 1,
  Prestataire = 2,
  Mixte = 3,
}

export const TypesContextesAutorisesEnumLibelle: EnumLibellé<TypesContextesAutorisesEnum> = {
  [TypesContextesAutorisesEnum.Aucun]: 'Aucun',
  [TypesContextesAutorisesEnum.Adherent]: 'Adhérent',
  [TypesContextesAutorisesEnum.Prestataire]: 'Prestataire',
  [TypesContextesAutorisesEnum.Mixte]: 'Mixte',
}

export type TypeContextCourant =
  | TypesContextesAutorisesEnum.Aucun
  | TypesContextesAutorisesEnum.Adherent
  | TypesContextesAutorisesEnum.Prestataire

export type ContextAppType = Uncapitalize<Exclude<TypeEntreprise, 'Inconnu'>>
export type ContextsApp = {
  [p in ContextAppType]?: PermissionsApp
}

export function typeContextCourantToContextAppType(contextCourant: TypeContextCourant): ContextAppType {
  switch (contextCourant) {
    case TypesContextesAutorisesEnum.Adherent:
      return 'adherent'
    case TypesContextesAutorisesEnum.Prestataire:
      return 'prestataire'
  }
  throw 'Non supporté'
}

